import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Configuration Firebase
export const firebaseConfig = {
  apiKey: "AIzaSyDguJXKeMJemOwxeKIJKOfr_TtfvUgOAW4",
  authDomain: "program-football.firebaseapp.com",
  projectId: "program-football",
  storageBucket: "program-football.firebasestorage.app",
  messagingSenderId: "605773275202",
  appId: "1:605773275202:web:17fa9c8265bbbcf5b94ddb",
  measurementId: "G-Z41WMF4CH7"
};

// Initialiser Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
console.log('[AUTH DEBUG] Firebase initialisé avec succès');

// Initialiser Analytics uniquement côté client
let analytics: any;
if (typeof window !== 'undefined') {
  isSupported().then(supported => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

// Exporter les services
export const auth = getAuth(app);
console.log('[AUTH DEBUG] Firebase Auth initialisé avec succès');

export const db = getFirestore(app);
console.log('[AUTH DEBUG] Firestore initialisé avec succès');

export const storage = getStorage(app);
console.log('[AUTH DEBUG] Firebase Storage initialisé avec succès');

export { analytics };
export default app;
